import { render, staticRenderFns } from "./DriverDocumentsTab.vue?vue&type=template&id=1e0d926f&scoped=true&"
import script from "./DriverDocumentsTab.vue?vue&type=script&lang=js&"
export * from "./DriverDocumentsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0d926f",
  null
  
)

export default component.exports